import StorageError from './StorageError';
import _ from './Utils.js'

function date_compare(a, b) {
    if (a.date > b.date) return 1;
    if (a.date < b.date) return -1;
    return 0;
}

// Implement a Sotrage interface that can just hold a data. It doesn't have any event bus per-se. It represents a DB layer instead.
const Storage = class {
    constructor() {
        this.store = null;
        this.metadata = {
            expenses: {
                "pk":"name"
            },
            transactionSplits: {
                "pk":"name"
            },
            accounts: {
                "pk":"name"
            },
            transactions: {
                "pk":"uuid",
                "orderby": date_compare
            },
            pendingTransactions: {
                "pk":"uuid",
                "orderby": date_compare
            }
        }
        this.index = {
            lastWritten: 'store'
        }
    }

    getDefaultStorage() {
        return {
                version: 0,
                expenses: { 
                    version: 0,
                    value: [{
                            version: 0,
                            name: 'happiness',
                            label: 'Happiness',
                            account: 'default'
                        },
                        {
                            version: 0,
                            name: 'rest',
                            label: 'Rest',
                            account: 'default'
                        },
                        {
                            version: 0,
                            name: 'savings',
                            label: 'Savings',
                            account: 'default'
                        },
                        {
                            version: 0,
                            name: 'charity',
                            label: 'Charity',
                            account: 'default'
                        },
                        {
                            version: 0,
                            name: 'other',
                            label: 'Other',
                            account: 'default',
                            default: true
                        },
                        {
                            version: 0,
                            name: 'selfdev',
                            label: 'Self-Development',
                            account: 'default'
                        }
                    ]
                },
                transactionSplits: { version: 0, value: [
                    {
                        version: 0,
                        name: 'income',
                        label: 'Income',
                        formulas: {
                            happiness:0.1,
                            rest: 0.1,
                            savings:0.1,
                            charity: 0.03,
                            other: 0.57,
                            selfdev: 0.1
                        }
                    },
                    {
                        version: 0,
                        name: 'happiness',
                        label: 'Happiness',
                        formulas: {
                            happiness:1
                        }
                    },
                    {
                        version: 0,
                        name: 'selfdev',
                        label: 'Self-Development',
                        formulas: {
                            selfdev:1
                        }
                    },
                    {
                        version: 0,
                        name: 'rest',
                        label: 'Rest',
                        formulas: {
                            rest:1
                        }
                    },
                    {
                        version: 0,
                        name: 'savings',
                        label: 'Savings',
                        formulas: {
                            savings:1
                        }
                    },
                    {
                        version: 0,
                        name: 'charity',
                        label: 'Charity',
                        formulas: {
                            charity:1
                        }
                    },
                    {
                        version: 0,
                        name: 'other',
                        label: 'Other',
                        formulas: {
                            other:1
                        }
                    },
                    {
                        version: 0,
                        name: 'custom',
                        label: 'Custom'
                        
                    },
                    {
                        version: 0,
                        name: 'none',
                        label: 'None'

                    }
                ]},

                accounts: { version: 0, value: [
                    {
                        version: 0,
                        name: 'default',
                        label: 'Default'
                    }

                ]},
                transactions: { version: 0, value: [
                    {
                        version: 0,
                        uuid: 'khbknkjsdnfkjsd',
                        date: _.getUTCTime('1/2/2018'),
                        description: 'Salary',
                        amount: 5099.99,
                        category: 'income', // how to split the transaction for expenses
                        status: 'processed', // processed or pending
                        splits: {
                            happiness: 509.99,
                            rest: 509.99,
                            savings: 509.99,
                            charity: 152.99,
                            other: 2096.99,
                            selfdev: 509.99
                        }
                    }
                ]},
                pendingTransactions: { version: 0, value: []}
            };
    }

    readLocalStorage(versionToRead) {
        this.readIndexStorage();
        var localStorage = window.localStorage;
        var storeStr = localStorage.getItem(versionToRead? versionToRead:this.index.lastWritten);
        if (storeStr) {
            try {
                this.store = JSON.parse(storeStr);
                this._normalizeData();
            }catch (e) {
                console.error("Couldn't load object saved in browser storage", e);
            }
        }
        if (!this.store) {
            // initial application launch
            this.store = this.getDefaultStorage();
        } 
    }

    _normalizeData() {
        const keys = Object.keys(this.metadata)
        for (const table of keys) {
            console.log("Normalizing "+table)
            if (!this.store[table]) {
                this.store[table] = {version:0, value: []};
            }
            if (this.metadata[table].orderby) {
                this.store[table].value.sort(this.metadata[table].orderby);
            }

            if (this.metadata[table].pk) {
                // filter out the duplicates
                let i;
                let map = {};
                let originalArray = this.store[table].value;
                let pk = this.metadata[table].pk;
                let withoutDuplicates = [];
                for (i =0; i< originalArray.length; i++)  {
                    let elem = originalArray[i];
                    let prevIndex = map[elem[pk]]
                    if (prevIndex || prevIndex === 0) {
                        // it's a duplicate
                        console.log(`Found duplicate item in ${table} table: ${JSON.stringify(elem)} at ${i} with ${originalArray[prevIndex]} at ${prevIndex}`);
                        let newPk, j = 1;
                        do {
                            newPk = elem[pk]+j;
                            j++;
                        }while(map[newPk] || map[newPk] === 0);
                        elem[pk] = newPk;
                    }
                    map[elem[pk]] = i;
                    withoutDuplicates.push(elem);
                }

                this.store[table].value=withoutDuplicates
            }
        }
    }

    getStore() {
        return this.store;
    } 
 
    save(storageTransaction) { 
        if (!storageTransaction.length){
            return this.store.version;
        }
        this.store.version = this.store.version + 1;
        var version = this.store.version;
        for (let i = 0; i < storageTransaction.length; i++) {
            let actionItem = storageTransaction[i];

            let table = this.store[actionItem.table];
            let pk = this.metadata[actionItem.table].pk;
            let id = actionItem.value[pk];
            let {foundItem} = this._find_by_id(table.value, pk, id);
            actionItem.value.version = this.store.version;
            if (actionItem.action === "INSERT") {
                if (foundItem) {
                    throw new StorageError("ITEM_ALREADY_EXISTS","The item with same name/id already exists, "+id);
                }
            } else if (actionItem.action === "UPDATE") {
                if (!foundItem) {
                    throw new StorageError("ITEM_NOT_FOUND", "Cannot find item with name/id "+id);
                }
                
            } else if (actionItem.action === "DELETE") {
                if (!foundItem) {
                    throw new StorageError("ITEM_NOT_FOUND", "Cannot find item with name/id "+id);
                }
            }
        }

        for (let i = 0; i < storageTransaction.length; i++) {
            let actionItem = storageTransaction[i];
            let table = this.store[actionItem.table];
            let pk = this.metadata[actionItem.table].pk;
            let id = actionItem.value[pk];
            let {foundItem, index} = this._find_by_id(table.value, pk, id);
            actionItem.value.version = this.store.version;
            let orderby = this.metadata[actionItem.table].orderby;
            if (actionItem.action === "INSERT") {
                this._insert(actionItem.value, table.value, this.metadata[actionItem.table].orderby);
                table.version = version;
            } else if (actionItem.action === "UPDATE") {
                if (!orderby(foundItem, actionItem.value)) {
                    table.value[index] = actionItem.value;
                } else {
                    table.value.splice(index, 1);
                    let insertPosition = this._insertLocationFor(actionItem.value, table.value, orderby);
                    this._insertAt(actionItem.value, table.value, insertPosition);

                }
                table.version = version;
            } else if (actionItem.action === "UPSERT") {
                // if (!foundItem) {
                //     table.value.push(actionItem.value);
                // } else {
                //     Object.assign(foundItem, actionItem.value);
                // }
                if (foundItem && !orderby(foundItem, actionItem.value)) {
                    table.value[index] = actionItem.value;
                } else {
                    if (foundItem) {
                        table.value.splice(index, 1)
                    }
                    this._insert(actionItem.value, table.value, orderby);
                }
                table.version = version;
            } else if (actionItem.action === "DELETE") {
                table.value.splice(index, 1)
                table.version = version;
            }
        }

        this._saveStore(false);

        return version;
    }

    _saveStore(forceBackup) {
        let serialized = JSON.stringify(this.store);

        let date = new Date();
        let formatted = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();

        let toBeSavedStore = 'store_'+formatted+((!forceBackup)?"":date.getHours()+":"+date.getMinutes()+":"+date.getSeconds());
        window.localStorage.setItem(toBeSavedStore, serialized);

        if (toBeSavedStore !== this.index.lastWritten ) {
            this.readIndexStorage();
            if (toBeSavedStore !== this.index.lastWritten ) {
                if (!this.index.allVersions) {
                    this.index.allVersions = [];
                }
                this.index.allVersions.push(toBeSavedStore);
                this.index.lastWritten = toBeSavedStore;
                window.localStorage.setItem("index", JSON.stringify(this.index));
                while (this.index.allVersions.length > 10) {
                    let toBeRemoved = this.index.allVersions.shift();
                    window.localStorage.removeItem(toBeRemoved);
                }
                window.localStorage.setItem("index", JSON.stringify(this.index));
            }
        }
    }


    readIndexStorage() {
        var localStorage = window.localStorage;
        var storeStr = localStorage.getItem('index');
        if (storeStr) {
            try {
                this.index = JSON.parse(storeStr);
            }catch (e) {
                console.error("Couldn't load object saved in browser storage", e);
            }
        }
        if (!this.index) {
            // initial application launch
            this.index = {
                lastWritten: "store",
                allVersions: ["store"]
            };
        }
    }

    exportAsJson() {
       return JSON.stringify(this.store);
    }

    importFromJson(data) {
        this.store=JSON.parse(data);
        this._saveStore(true);
    }

    truncate(table) {
        this.store.version = this.store.version + 1;
        var version = this.store.version;
        this.store[table].value=[];
        this.store[table].version = version;
        return version;
    }

    _insert(element, array, comparer) {
        if (!comparer) {
            array.push(element)
            return;
        }
        this._insertAt(element, array, this._insertLocationFor(element, array, comparer));
    }

    _insertAt(element, array, index) {
        array.splice(index, 0, element);
    }

    _getRightPosition(A, l, r, element, comparer) {
        let m;

        while( r - l > 1 ) {
            m = Math.floor(l + (r - l)/2);
            if( comparer(element, A[m])  >= 0 ) {
                l = m;
            } else {
                r = m;
            }
        }
        return l;
    }

    // Input: Indices Range (l ... r]
    // Invariant: A[r] >= key and A[l] > key
    _getLeftPosition(A, l, r, element, comparer) {
        let m;

        while( r - l > 1 ) {
            m = Math.floor(l + (r - l)/2);
            if( comparer(element, A[m])  <= 0 ) {
                r = m;
            } else {
                l = m;
            }
        }
        return r;
    }

    _insertLocationFor(element, array, comparer) {
        if (array.length === 0)
            return -1;

        let left = this._getLeftPosition(array, -1, array.length-1, element, comparer);
        let right = this._getRightPosition(array, 0, array.length, element, comparer);

        // 3 cases:   (date) < left < right
        //            left < (date) < right
        //            left < right < (date)
        if (comparer(element, array[left] ) < 0 ) {
            return left;
        } else if (comparer(array[right], element) < 0) {
            return right + 1;
        } else {
            return right + 1;
        }
    }

    _find_by_id(array, key, value) {
        for (var i = 0; i < array.length; i++) {
            var item = array[i];
            if (item[key] === value) {
                return {foundItem:item, index: i};
            }
        }
        return {foundItem:null, index: -1};
    }

    findById(tableName, pk) {
        var table = this.store[tableName];
        return this._find_by_id(table.value, this.metadata[tableName].pk, pk);
    }

    resetUnsafe() {
        window.localStorage.setItem('store', JSON.stringify(this.getDefaultStorage()));
        window.localStorage.setItem('index', null);
        this.readLocalStorage();
    }

    restoreBackup(selectedBackup) {
        this.readLocalStorage(selectedBackup);
    }
}

export default Storage;
